<div class="container" style="text-align: center">
  <a class="center-container" routerLink="/" routerLinkctive="active">
    <h2>Retornar</h2>
    <img class="img-screen" src="assets\img\not-found.png">
  </a>
</div>